import { componentsRegistryService } from "cruzo";
import { AbstractIcon } from "./abstract";

export class LockIcon extends AbstractIcon {
  static selector = "lock-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 17a2 2 0 002-2c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2zm6-7h-1V9a5 5 0 10-10 0v1H6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm-2 0H8V9c0-2.2 1.8-4 4-4s4 1.8 4 4v1z"/>
      </svg>`;
  }
}

componentsRegistryService.define(LockIcon);
